import React, {useState} from 'react';
import {
  Box,
  ButtonBase,
  Card,
  CardContent,
  Divider,
  Typography
} from '@mui/material';
import ClosedDoorLogo from 'assets/images/Door1.png';
import useStyles from './styles';

const VirtualRoom = props => {
    const {
      idx,
      virtualRoom,
      onRoomClick
    } = props;

    const classes = useStyles();
    const [hover, setHover] = useState(false);
    const [initialRender, setInitialRender] = useState(true);
    const handleMouseEnter = () => {
      setHover(true);
    }
    const handleMouseLeave = () => {
      setHover(false);
    }

    if (initialRender) {
      setInitialRender(false);
    }

    return (
      <React.Fragment>
        {virtualRoom &&
        <Card className={classes.cardRoot}
              onClick={() => onRoomClick(virtualRoom)}>
          <Box sx={{ minWidth: 50, width: 'auto' }}>
            <ButtonBase
                focusRipple
                key={virtualRoom.guid}
                className={classes.image}
            >
                <span className={classes.imageSrc} style={{backgroundImage: `url(${ClosedDoorLogo})`}} />
            </ButtonBase>
          </Box>
          <div className={classes.details}
               style={{
            ...({borderLeft: `15px solid`}),
            ...(hover && {borderLeft: `15px solid`}),
          }}
          >
            <CardContent className={classes.cardContent}>
              <Typography variant="h4" className={classes.appTitle}>
                <p>{virtualRoom.memberName}'s</p>
                <p>Virtual Room</p>
              </Typography>              <Divider/>
              <Typography
                className={classes.captionText}
                variant="body2"
              >
                Number of Documents: {virtualRoom.nbrDocuments}
              </Typography>
            </CardContent>
          </div>

        </Card>
        }
      </React.Fragment>);
  }
;

export default VirtualRoom;
